import {Component, OnInit} from '@angular/core';
import {Subject} from 'rxjs/Subject';
import {FormArray, FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {BsModalRef} from 'ngx-bootstrap';
import * as _ from 'lodash';
import {TessereService} from '../tessere.service';
import {createNumberMask} from 'text-mask-addons/dist/textMaskAddons';
import * as moment from 'moment';

@Component({
  selector: 'app-assegna-tessere',
  templateUrl: './assegna.component.html'
})

export class AssegnaTessereComponent implements OnInit {

  phisicalForm: FormGroup;
  digitalForm: FormGroup;
  assignableTypes: any[];
  association: any;
  selectedCardType = "1";

  closeBtnName: string;
  public onClose: Subject<any>;

  years: any[] = [];

  constructor(
    public bsModalRef: BsModalRef,
    private fb: FormBuilder,
    private tessereService: TessereService
  ) {
    this.onClose = new Subject();
  }

  ngOnInit() {
    this.initializeForm();
    this.populateYearsArray();
  }

  private populateYearsArray() {
    const now = moment();

    const year1 = now.year().toString();
    const year2 = now.add(1, 'year').year().toString();

    this.years.push(year1);
     //this.years.push(year2);
  }

  private initializeForm() {
    this.phisicalForm = this.fb.group({
      idAssociation: [this.association.id, Validators.required],
      type: this.fb.group({
        id: [null],
        code: [null, Validators.required],
        description: [null]
      }),
      year: [null, Validators.required],
      interval: this.fb.group({
        from: [null, Validators.required],
        to: [null, Validators.required]
      })
    })
    this.digitalForm = this.fb.group({
      idAssociation: [this.association.id, Validators.required],
      type: this.fb.group({
        id: [null, Validators.required],
        code: [null],
        description: [null]
      }),
      year: [null, Validators.required],
      amount: [null, Validators.required]
    })
  }

  changedElementOfInterval(isFrom: boolean) {

    const from = parseInt(this.phisicalForm.get('interval.from').value, 10);
    const to = parseInt(this.phisicalForm.get('interval.to').value, 10);

    if (isFrom) {
      this.phisicalForm.get('interval.from').setValue(from);
    } else {
      this.phisicalForm.get('interval.to').setValue(to);
    }

    if (isFrom && from < 0) {
      this.phisicalForm.get('interval.from').setValue(0);
    } else if (!isFrom && to < 0) {
      this.phisicalForm.get('interval.to').setValue(0);
    }

    if (to && from && to < from) {
      this.phisicalForm.get('interval.to').setValue(from);
    }
  }

  assegnaTessereCartacee() {
    const request = this.phisicalForm.getRawValue();

    const req: any = {};

    req.from = request.type.code + request.year.substring(2, 4) + '.' + request.interval.from.toString().padStart(6, '0');
    req.to = request.type.code + request.year.substring(2, 4) + '.' + request.interval.to.toString().padStart(6, '0');

    console.log(req);
    this.tessereService.assignPhysicalCards(this.association.id, req).subscribe((res) => {
      this.onClose.next(res);
      this.bsModalRef.hide();
    });
  }

  assegnaTessereDigitali() {
    const request = this.digitalForm.getRawValue();

    const req: any = {};

    req.idCardType = request.type.id;
    req.amount = request.amount;

    console.log(req);
    this.tessereService.assignDigitalCards(this.association.id, req).subscribe((res) => {
      this.onClose.next(res);
      this.bsModalRef.hide();
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/servizi/tessere/assegna-tessere/assegna.component.ts